export default __webpack_public_path__ + "static/media/71.ff195280.jpeg";